import * as React from "react"

const RweTopNok = (props) => (
    <svg
        width={896}
        height={815}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        viewBox={`0 0 896 815`}
        {...props}
    >
        <path
            d="M410.784 503.748c-10.522-6.075-23.865-2.664-29.802 7.619-5.937 10.284-2.22 23.545 8.302 29.62 10.523 6.075 23.866 2.664 29.803-7.62 5.937-10.283 2.22-23.544-8.303-29.619Z"
            fill="#B5179E"
        />
        <path
            d="M393.612 446.491c-11.718-6.766-26.702-2.751-33.467 8.967-6.766 11.718-2.751 26.702 8.967 33.468 11.719 6.765 26.703 2.75 33.468-8.968 6.766-11.718 2.751-26.702-8.968-33.467Z"
            fill="#560BAD"
        />
        <path
            d="M502.875 477.242c-10.284-5.937-23.433-2.414-29.37 7.869-5.937 10.284-2.414 23.433 7.87 29.37 10.283 5.937 23.432 2.414 29.369-7.87 5.937-10.283 2.414-23.432-7.869-29.369Z"
            fill="#F72585"
        />
        <path
            d="M527.045 425.379c-10.284-5.937-23.433-2.414-29.37 7.869-5.937 10.284-2.414 23.433 7.87 29.37 10.283 5.937 23.432 2.414 29.369-7.87 5.937-10.283 2.414-23.432-7.869-29.369Z"
            fill="#560BAD"
        />
        <path
            d="M512.507 361.56c-12.436-7.18-28.337-2.919-35.517 9.516-7.18 12.436-2.919 28.337 9.517 35.517 12.435 7.18 28.337 2.919 35.516-9.517 7.18-12.435 2.919-28.337-9.516-35.516Z"
            fill="#7209B7"
        />
        <path
            d="M332.523 307.299c-12.435-7.18-28.337-2.919-35.516 9.516-7.18 12.436-2.919 28.337 9.516 35.517 12.436 7.18 28.337 2.919 35.517-9.517 7.18-12.435 2.919-28.337-9.517-35.516Z"
            fill="#B5179E"
        />
        <path
            d="M323.33 408.223c-8.37-4.833-19.073-1.965-23.906 6.405-4.832 8.371-1.964 19.073 6.406 23.906 8.37 4.832 19.073 1.965 23.905-6.406 4.833-8.37 1.965-19.073-6.405-23.905Z"
            fill="#7209B7"
        />
        <path
            d="M408.65 300.444c-10.761-6.213-24.522-2.526-30.735 8.235-6.214 10.762-2.526 24.523 8.235 30.736 10.762 6.213 24.523 2.526 30.736-8.236 6.213-10.761 2.526-24.522-8.236-30.735Z"
            fill="#951E83"
        />
        <path
            d="M381.34 277.748c-10.762-6.213-24.523-2.526-30.736 8.235-6.213 10.762-2.526 24.523 8.236 30.736 10.761 6.213 24.522 2.526 30.735-8.236 6.213-10.761 2.526-24.522-8.235-30.735Z"
            fill="#F72585"
        />
        <path
            d="M492.612 275.018c-11.718-6.766-26.702-2.751-33.467 8.967-6.766 11.718-2.751 26.702 8.967 33.468 11.719 6.765 26.703 2.75 33.468-8.968 6.766-11.718 2.751-26.702-8.968-33.467Z"
            fill="#A51991"
        />
        <path
            d="M440.949 247.5c-8.131-4.694-18.528-1.909-23.222 6.222-4.694 8.131-1.909 18.528 6.222 23.223 8.131 4.694 18.528 1.908 23.223-6.223 4.694-8.131 1.908-18.528-6.223-23.222ZM551.966 316.214c-8.849-5.109-20.163-2.077-25.272 6.771-5.108 8.849-2.077 20.163 6.772 25.272 8.848 5.109 20.163 2.077 25.271-6.772 5.109-8.848 2.077-20.162-6.771-25.271ZM557.137 394.256c-6.696-3.866-15.258-1.572-19.124 5.125-3.866 6.696-1.572 15.258 5.124 19.124 6.696 3.866 15.259 1.572 19.125-5.124 3.866-6.697 1.571-15.259-5.125-19.125ZM576.901 371.025a4.499 4.499 0 0 0-6.147 1.647 4.5 4.5 0 1 0 7.794 4.5 4.5 4.5 0 0 0-1.647-6.147Z"
            fill="#B5179E"
        />
        <path
            d="M461.444 436.002c-10.044-5.799-22.887-2.358-28.686 7.686-5.799 10.044-2.358 22.888 7.686 28.687 10.044 5.799 22.888 2.357 28.687-7.687 5.799-10.044 2.357-22.887-7.687-28.686Z"
            fill="#7209B7"
        />
        <path
            d="M444.772 377.879c-8.37-4.832-19.073-1.965-23.905 6.405-4.833 8.371-1.965 19.073 6.405 23.906 8.37 4.832 19.073 1.965 23.906-6.406 4.832-8.37 1.964-19.073-6.406-23.905Z"
            fill="#B5179E"
        />
        <path
            d="M438.849 357.138c-5.261-3.037-11.989-1.235-15.027 4.027-3.037 5.261-1.234 11.988 4.027 15.026 5.261 3.037 11.988 1.235 15.026-4.026 3.038-5.262 1.235-11.989-4.026-15.027Z"
            fill="#B5179E"
        />
        <path
            d="M541.645 294.09a5.5 5.5 0 1 0 2.013 7.513 5.499 5.499 0 0 0-2.013-7.513Z"
            fill="#7209B7"
        />
        <path
            d="M349.892 376.216c-9.805-5.661-22.231-2.495-27.754 7.07-5.522 9.566-2.051 21.91 7.754 27.571 9.805 5.661 22.231 2.495 27.754-7.071 5.522-9.565 2.051-21.909-7.754-27.57ZM432.399 524.31c-8.609-4.971-19.618-2.021-24.589 6.588-4.97 8.61-2.02 19.618 6.589 24.589 8.609 4.97 19.618 2.021 24.588-6.589 4.971-8.609 2.021-19.618-6.588-24.588ZM314.95 465.738c-6.696-3.866-15.258-1.572-19.124 5.124-3.866 6.697-1.572 15.259 5.124 19.125 6.696 3.866 15.258 1.572 19.124-5.125 3.866-6.696 1.572-15.258-5.124-19.124ZM297.651 492.702a5.5 5.5 0 1 0 2.013 7.513 5.499 5.499 0 0 0-2.013-7.513ZM346.055 499.862c-5.74-3.313-13.079-1.347-16.392 4.393-3.314 5.739-1.348 13.078 4.392 16.392 5.739 3.314 13.079 1.347 16.392-4.392 3.314-5.74 1.347-13.079-4.392-16.393Z"
            fill="#B5179E"
        />
        <path
            d="M305.38 386.313c-8.609-4.971-19.618-2.021-24.588 6.588-4.971 8.61-2.021 19.618 6.588 24.589 8.61 4.97 19.618 2.021 24.589-6.589 4.97-8.609 2.021-19.617-6.589-24.588ZM260.555 438.952c-3.588-2.071-8.286-.648-10.496 3.179-2.209 3.826-1.092 8.607 2.496 10.678 3.587 2.071 8.286.648 10.495-3.178 2.209-3.827 1.092-8.607-2.495-10.679ZM384.098 507.97c-8.131-4.694-18.528-1.909-23.223 6.222-4.694 8.131-1.908 18.528 6.223 23.223 8.131 4.694 18.528 1.908 23.222-6.223 4.695-8.131 1.909-18.528-6.222-23.222ZM505.613 349.497c-5.261-3.037-11.988-1.235-15.026 4.027-3.037 5.261-1.235 11.988 4.026 15.026 5.262 3.037 11.989 1.235 15.027-4.026 3.037-5.262 1.235-11.989-4.027-15.027Z"
            fill="#F72585"
        />
        <path
            d="M510 239.408H317c-39.212 0-71 31.788-71 71v183c0 39.212 31.788 71 71 71h193c39.212 0 71-31.788 71-71v-183c0-39.212-31.788-71-71-71Z"
            fill="#191822"
            style={{
                mixBlendMode: "color",
            }}
            opacity={0.638}
        />
        <text
            fill="#FAFAFA"
            xmlSpace="preserve"
            style={{
                whiteSpace: "pre",
            }}
            fontFamily="Poppins"
            fontSize={26}
            letterSpacing="0em"
        >
            <tspan x={350.337} y={420.6}>
                {"PACIENTES"}
            </tspan>
        </text>
    </svg>
)

export default RweTopNok
